// extracted by mini-css-extract-plugin
module.exports = {"product-image-panel":"ProductImageDisplay_product-image-panel___JXvM"};